import { defineMessages } from 'react-intl';

export default defineMessages({
    coverages: {
        id: 'ml.common.component.MLEditableCoverages.coverages',
        defaultMessage: 'Coverages'
    },
    limits: {
        id: 'ml.common.component.MLEditableCoverages.limits',
        defaultMessage: 'Limits'
    },
    monthlyPremium: {
        id: 'ml.common.component.MLEditableCoverages.monthlyPremium',
        defaultMessage: 'Monthly Premium'
    },
    premium: {
        id: 'ml.common.component.MLEditableCoverages.premium',
        defaultMessage: 'Premium'
    }
});
